<template>
  <b-container class="main-content details-page" v-if="loading">
    <div class="d-flex align-items-center">
      <strong>Lade Daten...</strong>
      <b-spinner type="grow" label="Loading..." class="loader ml-auto"></b-spinner>
    </div>
    <b-alert show variant="danger" v-if="error">Fehler beim laden!</b-alert>
  </b-container>
  <b-container class="main-content details-page" v-else>
    <h1>Volksinitiative «{{ proposal.name }}»</h1>
    <b-row>
      <b-col lg="3" class="order-lg-last">
        <b-row>
          <b-col>
            <h2>Aufpassen!</h2>
            <p>
              <b>Abstimmung am {{ proposal.effectiveDate }}</b>
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-between">
          <b-col sm="5" lg="12">
            <b-row>
              <b-col>
                <router-link class="btn btn-primary btn-block mb-3" role="button" :to="{ name: 'abstimmung', params: { proposalName: proposal.id }}">Jetzt abstimmen!</router-link>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="5" lg="12">
            <b-row>
              <b-col>
                <router-link class="btn btn-secondary btn-block mb-3" role="button" :to="{ name: 'ergebnisse', params: { proposalName: proposal.id }}">Ergebnisse anzeigen</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="9" v-html="proposal.content"></b-col>
    </b-row>
  </b-container>
</template>

<script>
import client from 'api-client';

export default {
  name: 'Details',
  data() {
    return {
      loading: true,
      proposal: {},
      error: false,
    };
  },
  props: ['id'],
  created() {
    client
      .fetchProposal(this.id)
      .then(proposal => this.setProposal(proposal))
      .catch((e) => {
        console.error(e);
        this.error = true;
      });
  },
  methods: {
    setProposal(proposal) {
      this.proposal = proposal;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.loader{
  width: 3rem;
  height: 3rem;
}
</style>
